module.exports = __webpack_public_path__ + "static/media/runing.770e3e91.svg";